export const CUSTOMER_ACCOUNT_TYPE = {
  MEMBER: 'MEMBER',
  TOURIST: 'TOURIST',
  AGENT: 'AGENT',
  AMBASSADOR: 'AMBASSADOR',
};

export const CUSTOMER_ACCOUNT_TYPE_LABELS = {
  [CUSTOMER_ACCOUNT_TYPE.MEMBER]: 'Thành viên',
  [CUSTOMER_ACCOUNT_TYPE.TOURIST]: 'Du khách',
  [CUSTOMER_ACCOUNT_TYPE.AGENT]: 'Đại lý',
  [CUSTOMER_ACCOUNT_TYPE.AMBASSADOR]: 'Đại sứ',
};

export const CUSTOMER_LABEL_TO_ACCOUNT_TYPE = Object.entries(
  CUSTOMER_ACCOUNT_TYPE_LABELS,
).reduce((acc, [value, label]) => ({
  ...acc,
  [label]: value,
}), {});

export const CUSTOMER_ACCOUNT_TYPE_OPTIONS = Object.values(CUSTOMER_ACCOUNT_TYPE).map(
  (value) => ({
    label: CUSTOMER_ACCOUNT_TYPE_LABELS[value],
    value,
  }),
);
